import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { IHisInformationValue, HisInformationDateTimeValue } from "../../HisInformationValue";
import { DefaultCreateDateBehavior } from "./DefaultCreateDateBehavior";

/** HIS項目現在の日付を生成する */
export class FilledCreateDateBehavior implements IHisInfoItemBehavior {
  constructor(private key: string, private defaultDateFormat?: string) {}
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const defaultBehavior = new DefaultCreateDateBehavior(this.key, this.defaultDateFormat);
    const value = defaultBehavior.getValue(hisInfoItems);
    const data = value.data.length > 0 ? value.data : [ new Date() ];
    return new HisInformationDateTimeValue(this.key, data, this.defaultDateFormat);
  }
}
